if (!customElements.get('flavor-picker')) {
  customElements.define(
    'flavor-picker',
    class FlavorPicker extends HTMLElement {
      constructor() {
        super()
        this.initialized = false
        this.debug = false
        this.observer = null
        this.original_flavor_value = null
        if (this.debug) console.log('FlavorPicker constructor')
      }

      connectedCallback() {
        if (this.initialized) return
        this.initialized = true
        if (this.debug) console.log('FlavorPicker connectedCallback')
        this.flavorHover()
        // Dispatch event when flavor picker is ready
        window.dispatchEvent(new CustomEvent('flavor-picker:initialized'))
      }

      disconnectedCallback() {}

      // Method to set up hover functionality
      flavorHover() {
        this.original_flavor_value = this.querySelector('.flavor_value').innerHTML

        // Select all product-switch elements within the flavor-picker container
        const productSwitches = this.querySelectorAll('.product-switch')

        // Add event listeners to each product switch for hover
        productSwitches.forEach((productSwitch) => {
          productSwitch.addEventListener('mouseover', this.handleMouseOver.bind(this, productSwitch))
          productSwitch.addEventListener('mouseout', this.handleMouseOut.bind(this, productSwitch))
          productSwitch.addEventListener('click', this.handleMouseClick.bind(this, productSwitch))
        })

        // Add an event listener for mouseout on the entire flavor-picker container
        // But this time only reset the flavor when the mouse leaves the .product-switches container
        const productSwitchesContainer = this.querySelector('.product-switches')
        productSwitchesContainer.addEventListener('mouseout', this.handleProductSwitchesMouseOut.bind(this))
      }

      handleMouseClick(element) {
        const productHandle = element.getAttribute('data-product-handle')
        if (!productHandle) return

        // Check if we're on a product page
        const isProductPage = window.location.pathname.includes('/products/')
        
        if (isProductPage) {
          // If on product page, redirect to the new product
          window.location.href = `/products/${productHandle}`
          return
        }

        const productSection = document.querySelector('section[data-section-type="product"]')
        if (!productSection) return

        // Add loading state
        productSection.style.opacity = '0.6'

        // Fetch the section HTML
        fetch(`/products/${productHandle}?section_id=main-product`)
          .then(res => res.text())
          .then(html => {
            // Create temporary container and parse HTML
            const temp = document.createElement('div')
            temp.innerHTML = html

            // Find the product section in the fetched HTML
            const newProductSection = temp.querySelector('section[data-section-type="product"]')
            if (!newProductSection) return

            // Update just the product section content
            productSection.innerHTML = newProductSection.innerHTML

            // Reinitialize components
            this.reinitializeComponents()

            // Dispatch custom event for other components
            window.dispatchEvent(new CustomEvent('shopify:section:load', {
              detail: { sectionId: productSection.dataset.sectionId }
            }))
          })
          .catch(error => {
            console.error('Error updating product:', error)
          })
          .finally(() => {
            productSection.style.opacity = '1'
          })
      }

      // Handle the hover effect when mouse enters a product switch
      handleMouseOver(element) {
        const hoveredProductFlavor = element.getAttribute('data-product-flavor')
        const colorContainer = element.querySelector('.color-container')

        // Only change the flavor when hovering over a product switch
        if (element.classList.contains('product-switch')) {
          // Adjust the color container size for hover effect but only if it's not the active product switch
          if (!element.classList.contains('active')) {
            colorContainer.style.height = 'calc(100% - 2px)'
            colorContainer.style.width = 'calc(100% - 2px)'
          }
          // Update the flavor text based on the hovered product switch's flavor
          const flavorValue = this.querySelector('.flavor_value')
          flavorValue.innerHTML = hoveredProductFlavor
        }
      }

      // Handle mouseout on a product switch (reset color container size)
      handleMouseOut(element) {
        const colorContainer = element.querySelector('.color-container')

        // Only reset the size of the color container, not the flavor name
        if (element.classList.contains('product-switch')) {
          colorContainer.style.height = 'calc(100% - 4px)'
          colorContainer.style.width = 'calc(100% - 4px)'
        }
      }

      // Handle mouseout when leaving the .product-switches container
      handleProductSwitchesMouseOut(event) {
        // Check if the mouse leaves the .product-switches container
        const relatedTarget = event.relatedTarget

        // If mouse leaves the .product-switches container, reset the flavor
        if (!this.querySelector('.product-switches').contains(relatedTarget)) {
          this.querySelector('.flavor_value').innerHTML = this.original_flavor_value
        }
      }

      reinitializeComponents() {
        // Reinitialize product image slider
        const imageSlider = document.querySelector('.product__media[data-slider2]')
        if (window.jQuery && imageSlider) {
          const $slider = jQuery(imageSlider)
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick')
          }
          $slider.slick({
            dots: true,
            arrows: true,
            prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0615/4479/2259/files/left-arrow.png?v=1695734554"></button>',
            nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0615/4479/2259/files/right-arrow.png?v=1695734554"></button>'
          })
        }

        // Reinitialize zoom functionality
        if (window.jQuery && jQuery.fn.zoom) {
          jQuery('.imgprdmed').each(function() {
            jQuery(this).zoom()
          })
        }

        // Reinitialize flavor picker events
        this.flavorHover()

        // Dispatch events for theme's product form initialization
        window.dispatchEvent(new CustomEvent('product:section:updated'))
        window.dispatchEvent(new CustomEvent('variant:change'))
      }
    }
  )
}
